import React from 'react'
import { Link as SmoothScroll } from 'react-scroll'
import { Accordion } from '@mc/design-system'
import { Trans } from '@mc/i18n'

interface SharedFaqItemProps {
  question: string
  answer: string
}

const SharedFaqItem = ({ question, answer }: SharedFaqItemProps) => (
  <Accordion.Item
    className='mc-mb-4 mc-text--bold'
    uuid={question}
    label={<span>{question}</span>}
  >
    <div className='mc-opacity--hinted'>
      <Trans i18nKey={answer} ns='@mc/next'>
        <p></p>
        <SmoothScroll
          to='contact-form'
          className='mc-text--link'
          smooth
          offset={-100}
          href='#contact-form'
        ></SmoothScroll>
        <br />
      </Trans>
    </div>
  </Accordion.Item>
)

export default SharedFaqItem
